var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "rotate(-90 12.5 12.5)",
    fill: "#F5F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7135 13.3193L12.3297 16.2501C12.0188 16.5914 11.4841 16.5817 11.1854 16.2294C10.9318 15.9303 10.9392 15.4861 11.2025 15.1958L14.3622 12.5L11.2025 9.80419C10.9392 9.51393 10.9318 9.06967 11.1854 8.7706C11.4841 8.41825 12.0188 8.40858 12.3297 8.7499L15.7135 11.6807C15.7135 11.6807 16 12.0158 16 12.5C16 12.9842 15.7135 13.3193 15.7135 13.3193Z",
    fill: "#080B11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCollapse);
export default __webpack_public_path__ + "static/media/list_collapse.6892652e6677bb264fa990d8f20749d2.svg";
export { ForwardRef as ReactComponent };